import React from "react";
import { Card, CardContent } from "../../components/ui/card";
import { Badge } from "../../components/ui/badge";
import { Button } from "../../components/ui/button";
import {
  AlertDialog,
  AlertDialogTrigger,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogAction,
  AlertDialogCancel,
} from "../../components/ui/alert-dialog";

const STATUS_BORDER = {
  pendente:   "border-l-amber-400",
  confirmado: "border-l-blue-500",
  concluido:  "border-l-emerald-500",
  cancelado:  "border-l-red-400",
};

const STATUS_BADGE_CLASS = {
  pendente:   "bg-amber-100 text-amber-700",
  confirmado: "bg-blue-100 text-blue-700",
  concluido:  "bg-emerald-100 text-emerald-700",
  cancelado:  "bg-red-100 text-red-600",
};

export default function AdminAgendamentos({ dados, onConfirmar, onConcluir, onCancelar }) {
  return (
    <div id="admin-jobs-list-wrapper" className="flex flex-col gap-3">
      {dados.map((a) => {
        const shortId = a.id.substring(0, 8);
        const borderCls = STATUS_BORDER[a.status] ?? "border-l-border";
        return (
          <Card
            key={a.id}
            id={`admin-job-card-${shortId}`}
            className={`border-l-4 ${borderCls}`}
          >
            <CardContent className="flex items-center justify-between gap-3 p-3">
              <div id={`admin-job-info-box-${shortId}`} className="flex-1 min-w-0 space-y-0.5">
                <strong id={`admin-job-client-name-${shortId}`} className="block text-sm font-semibold text-foreground truncate">
                  {a.familia?.nome}
                </strong>
                <p id={`admin-job-nanny-name-${shortId}`} className="text-xs text-muted-foreground">👶 {a.baba?.nome}</p>
                <p id={`admin-job-schedule-time-${shortId}`} className="text-xs text-muted-foreground">
                  📅 {new Date(a.inicio).toLocaleDateString()} ⏰{" "}
                  {new Date(a.inicio).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
                </p>
                <Badge
                  id={`admin-job-status-badge-${shortId}`}
                  variant="outline"
                  className={STATUS_BADGE_CLASS[a.status] ?? ""}
                >
                  {a.status}
                </Badge>
              </div>

              <div id={`admin-job-actions-container-${shortId}`} className="flex flex-col gap-1.5 shrink-0">
                {a.status === "pendente" && (
                  <Button
                    id={`admin-btn-confirm-job-${shortId}`}
                    size="sm"
                    onClick={() => onConfirmar(a.id)}
                  >
                    Confirmar
                  </Button>
                )}
                {a.status === "confirmado" && (
                  <Button
                    id={`admin-btn-complete-job-${shortId}`}
                    size="sm"
                    className="bg-emerald-500 text-white hover:bg-emerald-600"
                    onClick={() => onConcluir(a.id)}
                  >
                    Concluir
                  </Button>
                )}
                <AlertDialog>
                  <AlertDialogTrigger asChild>
                    <Button
                      id={`admin-btn-cancel-job-${shortId}`}
                      size="sm"
                      variant="destructive"
                    >
                      Cancelar
                    </Button>
                  </AlertDialogTrigger>
                  <AlertDialogContent>
                    <AlertDialogHeader>
                      <AlertDialogTitle>Cancelar agendamento?</AlertDialogTitle>
                      <AlertDialogDescription>
                        O agendamento de {a.familia?.nome} com {a.baba?.nome} será cancelado.
                      </AlertDialogDescription>
                    </AlertDialogHeader>
                    <AlertDialogFooter>
                      <AlertDialogCancel>Voltar</AlertDialogCancel>
                      <AlertDialogAction variant="destructive" onClick={() => onCancelar(a)}>
                        Cancelar agendamento
                      </AlertDialogAction>
                    </AlertDialogFooter>
                  </AlertDialogContent>
                </AlertDialog>
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
